export function ClipboardIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M6.66665 4.16667C6.66665 3.24619 7.41284 2.5 8.33331 2.5H9.99998C10.9205 2.5 11.6666 3.24619 11.6666 4.16667C11.6666 5.08714 10.9205 5.83333 9.99998 5.83333H8.33331C7.41284 5.83333 6.66665 5.08714 6.66665 4.16667Z'
        fill='currentColor'
      />
      <path
        d='M6.66665 4.16667H4.99998C4.07951 4.16667 3.33331 4.91286 3.33331 5.83333V15.8333C3.33331 16.7538 4.07951 17.5 4.99998 17.5H13.3333C14.2538 17.5 15 16.7538 15 15.8333V15M6.66665 4.16667C6.66665 5.08714 7.41284 5.83333 8.33331 5.83333H9.99998C10.9205 5.83333 11.6666 5.08714 11.6666 4.16667M6.66665 4.16667C6.66665 3.24619 7.41284 2.5 8.33331 2.5H9.99998C10.9205 2.5 11.6666 3.24619 11.6666 4.16667M11.6666 4.16667H13.3333C14.2538 4.16667 15 4.91286 15 5.83333V8.33333M16.6666 11.6667H8.33331M8.33331 11.6667L10.8333 9.16667M8.33331 11.6667L10.8333 14.1667'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
